<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Notice
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage
    },
    data() {
        return {
            subMenus: [
                {
                    'title': 'Branch Notice',
                    'active': route().current('notice.branch.list'),
                    'route': 'notice.branch.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Notice' || permission.name === 'Edit Notice' || permission.name === 'View Notice')
                },
                {
                    'title': 'Teacher Notice',
                    'active': route().current('notice.teacher.list'),
                    'route': 'notice.teacher.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Notice' || permission.name === 'Edit Notice' || permission.name === 'View Notice')
                }, {
                    'title': 'Student Notice',
                    'active': route().current('notice.student.list'),
                    'route': 'notice.student.list',
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Notice' || permission.name === 'Edit Notice' || permission.name === 'View Notice')
                }]
        }
    },
}
</script>
